export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT as EnvType

export enum EnvType {
  Local = 'local',
  Qa = 'qa',
  Staging = 'staging',
  Sandbox = 'sandbox',
  Production = 'production',
  Test = 'test',
}

export const envDomain: Record<EnvType, string> = {
  [EnvType.Local]: 'localhost',
  [EnvType.Test]: '.test.loadsmart.com',
  [EnvType.Qa]: '.qa.loadsmart.com',
  [EnvType.Staging]: '.staging.loadsmart.com',
  [EnvType.Sandbox]: '.sandbox.loadsmart.com',
  [EnvType.Production]: '.loadsmart.com',
}

export const __DEV__ = process.env.NODE_ENV === 'development'
export const __TEST__ = process.env.NODE_ENV === 'test'
export const __PROD__ = process.env.NODE_ENV === 'production'

export const __STAGING__ = ENVIRONMENT === EnvType.Staging

export const ALL_ENV = [
  EnvType.Local,
  EnvType.Qa,
  EnvType.Staging,
  EnvType.Sandbox,
  EnvType.Production,
  EnvType.Test,
]

export const ALL_BUT_PRODUCTION = [
  EnvType.Local,
  EnvType.Qa,
  EnvType.Staging,
  EnvType.Sandbox,
  EnvType.Test,
]

export const API_URL = process.env.REACT_APP_API_URL
export const SHIPPER_GUIDE_API_URL = process.env.REACT_APP_SHIPPER_GUIDE_API_URL
export const SHIPPER_GUIDE_APP_URL = process.env.REACT_APP_SHIPPER_GUIDE_APP_URL
export const CHAT_BACKEND_URL = process.env.REACT_APP_CHAT_BACKEND_URL

export const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY
export const COMPASS_API_KEY = process.env.REACT_APP_COMPASS_API_KEY

export const IS_MSW_ACTIVE = process.env.REACT_APP_IS_MSW_ACTIVE === 'true'

export const CARRIER_GUIDE_URL = process.env.REACT_APP_KAMION_URL
export const LOADS_APP_URL = process.env.REACT_APP_LOADS_APP_URL
